import { useState } from 'react';
import { toast } from 'react-toastify';
import validLookup from '../utils/validLookup';

const useDeleteRecord = (showConfirmationDialog, closeConfirmationDialog) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const deleteRecords = async (rowids, deleteServiceFunction, onSuccess, onFailure) => {
        showConfirmationDialog(async (action) => {
            if (action === validLookup.confirmationDialogAction.ok) {
                setIsDeleting(true); // Start deletion

                try {
                    const deleteRecordResult = await deleteServiceFunction(rowids.map(x => parseInt(x, 10)));
                    const { code, message, data } = deleteRecordResult;

                    if (code === 0) {
                        toast.success(message || "Record(s) deleted successfully");
                        if (onSuccess) {
                            onSuccess(data); // Call the success callback
                        }
                        //const updateList = state.data.filter(d => !rowids.map(x => parseInt(x, 10)).includes(d.id));
                        //updateState({ data: updateList });
                    } else {
                        toast.error(message || "Failed to delete record(s)");
                        if (onFailure) {
                            onFailure(message); // Call the failure callback
                        }
                    }
                } catch (error) {
                    toast.error("An error occurred during deletion.");
                    if (onFailure) {
                        onFailure("An error occurred during deletion.");
                    }
                } finally {
                    setIsDeleting(false); // End deletion
                    closeConfirmationDialog();
                }
            } else {
                closeConfirmationDialog();
            }
        }, {
            title: 'Delete record',
            message: `Please confirm if you would like to delete ${rowids.length} record(s)?`,
        });
    };

    return { deleteRecords, isDeleting };
};

export default useDeleteRecord;